module.exports = __webpack_public_path__ + "img/q4.c78ec818.png";